"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * Helper function for Slot.
 * It can be used to define Master slides
 * @see function#static-function-create
 * @public
 * @return {null}
 */
var Slot = exports.Slot = function Slot() {
  return null;
};
/**
 * Helper function for Static.
 * It can be used to define Master slides
 * @see function#static-function-create
 * @public
 * @return {null}
 */
var Static = exports.Static = function Static() {
  return null;
};
/**
 * Helper function for Master.
 * It can be used to define Master slides
 * @see function#static-function-create
 * @public
 * @return {null}
 */
var Master = exports.Master = function Master() {
  return null;
};
//# sourceMappingURL=components.js.map